import React from "react";
import editIcon from "../../assets/images/Icons/editIcon.png";
import { Box, Menu, MenuItem } from "@mui/material";
import archiveIcon from "../../assets/images/Icons/ic_archive.png";

export const SimpleMenu = ({
  row,
  handleDeleteModal,
  detailAction,
  editAction,
  archiveAction,
  isEditable = false,
  isDeletable = false,
  customTrigger = null,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      {customTrigger ? (
        customTrigger({ onClick: handleClick })
      ) : (
        <Box
          component="img"
          sx={{ cursor: "pointer" }}
          src="/icons/ic_more_horizontal.svg"
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        />
      )}

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ padding: "8px", gap: "2px", borderRadius: "10px" }}
      >
        {detailAction && (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              detailAction(row.original);
              handleClose();
            }}
            sx={{
              width: "172px",
              padding: "6px 8px",
              gap: "8px",
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
            }}
          >
            <Box component="img" src={editIcon} height={20} width={20} />
            Detail
          </MenuItem>
        )}
        {archiveAction && (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              archiveAction(row.original);
              handleClose();
            }}
            sx={{
              width: "172px",
              padding: "6px 8px",
              gap: "8px",
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
            }}
          >
            <Box component="img" src={archiveIcon} height={20} width={20} />
            Archive
          </MenuItem>
        )}
        {editAction && isEditable && (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              editAction(row.original);
              handleClose();
            }}
            sx={{
              width: "172px",
              padding: "6px 8px",
              gap: "8px",
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
            }}
          >
            <Box component="img" src={editIcon} height={20} width={20} />
            Edit
          </MenuItem>
        )}
        {handleDeleteModal && isDeletable && (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              handleDeleteModal(row.original);
              handleClose();
            }}
            sx={{
              width: "172px",
              padding: "6px 8px",
              gap: "8px",
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
            }}
          >
            <Box
              component="img"
              src="/icons/ic_trash_sm.png"
              height={20}
              width={20}
            />
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
